<template>
  <div class="amendment-box">
    <ul v-if="amendments && amendments.length" class="amendment-box__list">
      <li v-for="amendment in amendments" :key="amendment.id">
        <span class="amendment-box__note">{{ amendment.note }}</span>
        <span v-if="amendment.createdAt" class="amendment-box__date">
          {{ formatDate(amendment.createdAt) }}
        </span>
      </li>
    </ul>

    <div class="amendment-box__composer">
      <b-input
        v-model="draftNote"
        type="textarea"
        rows="2"
        placeholder="Add a note if this looks off (a passive annotation — it won't change the computed value)"
        :disabled="isSubmitting"
      />
      <b-button
        type="is-light"
        size="is-small"
        :loading="isSubmitting"
        :disabled="!draftNote || !draftNote.trim()"
        @click="submit"
      >
        Add amendment
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmendmentBox',
  props: {
    amendments: {
      type: Array,
      default: () => [],
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit'],
  data() {
    return {
      draftNote: '',
    }
  },
  methods: {
    submit() {
      if (!this.draftNote || !this.draftNote.trim()) return
      this.$emit('submit', this.draftNote.trim())
      this.draftNote = ''
    },
    formatDate(value) {
      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? '' : date.toISOString().slice(0, 10)
    },
  },
}
</script>

<style lang="scss" scoped>
.amendment-box {
  border-top: 1px solid $color-border-muted;
  padding-top: $space-3;
  display: grid;
  gap: $space-3;
}

.amendment-box__list {
  margin: 0;
  padding-left: 1.1rem;
  list-style: disc;
  display: grid;
  gap: $space-2;
}

.amendment-box__note {
  color: $color-text;
}

.amendment-box__date {
  margin-left: $space-2;
  color: $color-text-muted;
  font-size: $font-size-xs;
}

.amendment-box__composer {
  display: grid;
  gap: $space-2;
  justify-items: start;
}
</style>
